export default __webpack_public_path__ + "static/media/DAIF_Data_Loop_Comp.8fed6b27.mp4";